// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__fAwSm","input":"styles_input__DKz1M","btn":"styles_btn__jEl-w","btn_delete":"styles_btn_delete__mnAQ2","btn_edit":"styles_btn_edit__ZNFeH"};